import { Component, computed, inject } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { Note } from 'src/app/calvin-emr-shared/models/note.model';
import { OrderSet } from 'src/app/calvin-emr-shared/models/order-set.model';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';

@Component({
  selector: 'app-order-set-view-dialog',
  imports: [
    ButtonDirective,
    TableModule,
  ],
  templateUrl: './order-set-view-dialog.component.html',
  styleUrl: './order-set-view-dialog.component.scss',
  standalone: true,
})
export class OrderSetViewDialogComponent {
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private patientStore = inject(PatientDashboardStore);

  orderSet: OrderSet = this.config.data as OrderSet;

  readonly nursingOrders = computed<Note[]>(() =>
    this.patientStore.patient().nursingOrders.filter((no: Note) =>
      this.orderSet.nursingOrderIds.includes(no.id)
    )
  );

  readonly providerOrders = computed<ProviderOrder[]>(() =>
    this.patientStore.patient().providerOrders.filter((po: ProviderOrder) =>
      this.orderSet.providerOrderIds.includes(po.id)
    )
  );

  closeDialog() {
    this.ref.close();
  }
}
